import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { AppConfig } from "../app.config";
import { NotifyService } from '../shared/shared';
import { Observable } from 'rxjs/Observable';
import { VertragModel } from '../schemas/schemas';
import { ExtendedJwtHttp } from '../_authentication/http/jwthttp';

@Injectable()
export class VertragService {

    constructor(private jwtHttp: ExtendedJwtHttp, private notfiySrv: NotifyService) {

    }

    public getVertragById(id: string): Observable<VertragModel> {

        return this.jwtHttp.get(AppConfig.Urls.WebAPI + '/api/vertrag/getVertragById', {
            params: {
                id: id
            }
        })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let data: VertragModel[] = res.json() || [];
        return data;
    }
    
    private handleError(error: Response | any) {
        // In a real world app, we might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            errMsg = `${error.status} - ${error.statusText || ''}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag.service.ts